/*
  Faith Based District theme: cart drawer, card quick add, PDP buy box. Ported from site_rebuild/mockups/fbd-cart.js.

  - Cart state is Shopify's /cart.js shape. Lines also carry client-only flags: loading (transient), error (sticky).
  - Optimistic lines are drawn from data-* on the add form (title/handle/url/image) and the picked radio
    (variant title, price), then replaced by the server's cart as soon as it answers.
  - Upsells are rendered server-side by sections/fbd-cart-upsell.liquid (order data via custom.upsell) and swapped in
    through the Section Rendering API on every cart change.
  - Every form is a real Shopify form, so the site still works with JS off.
*/
(function () {
  "use strict";
  document.documentElement.classList.add("js");

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var readJSON = function (sel, fallback) {
    var el = $(sel);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  };

  var cart = readJSON("[data-fbd-cart]", { items: [], item_count: 0, total_price: 0 });
  var money = function (cents) { return "$" + (cents / 100).toFixed(2).replace(/\.00$/, ""); };
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var UPSELL_SECTION = "fbd-cart-upsell";

  /* What the optimistic line needs, read from the add form + picked radio. */
  function lineDataFromInput(input) {
    var form = input && input.form;
    if (!form) return null;
    return {
      id: Number(input.value), handle: form.dataset.handle || "", product_title: form.dataset.title || "",
      url: form.dataset.url || "#", image: form.dataset.image || "",
      variant_title: input.dataset.variantTitle || "", price: Number(input.dataset.price || 0)
    };
  }

  /* ================= Shopify Ajax Cart API ================= */
  var latestUpsell = null;   // HTML of sections/fbd-cart-upsell from the last mutation
  function post(url, body) {
    return fetch(ROOT + url, {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || "Couldn't update the cart. Try again.");
        return data;
      });
    });
  }
  var api = {
    add: function (id, qty) {
      return post("cart/add.js", { items: [{ id: Number(id), quantity: qty }], sections: UPSELL_SECTION, sections_url: location.pathname })
        .then(function (data) { if (data.sections) latestUpsell = data.sections[UPSELL_SECTION]; return data; });
    },
    change: function (key, qty) {
      return post("cart/change.js", { id: key, quantity: qty, sections: UPSELL_SECTION, sections_url: location.pathname })
        .then(function (data) { if (data.sections) latestUpsell = data.sections[UPSELL_SECTION]; return data; });
    },
    get: function () {
      return fetch(ROOT + "cart.js", { credentials: "same-origin", headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); });
    },
    upsell: function () {
      return fetch(ROOT + "?sections=" + UPSELL_SECTION, { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (data) { latestUpsell = data[UPSELL_SECTION]; });
    }
  };
  /* ================================ END API ================================ */

  /* ---------- drawer open/close ---------- */
  var drawer = $("[data-fbd-drawer]");
  var overlay = $("[data-fbd-overlay]");
  var lastOpener = null;

  function openDrawer(opener) {
    if (!drawer) return;
    lastOpener = opener || document.activeElement;
    overlay.hidden = false;
    void overlay.offsetWidth;            // flush styles so the fade-in transition runs from opacity 0
    overlay.classList.add("is-open");
    drawer.classList.add("is-open");
    drawer.removeAttribute("inert");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
    var close = $("[data-fbd-drawer-close]", drawer);
    if (close) close.focus();
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains("is-open")) return;
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-open");
    drawer.setAttribute("inert", "");
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
    setTimeout(function () { overlay.hidden = true; }, 200);
    if (lastOpener && lastOpener.focus) lastOpener.focus();
  }

  $$("[data-fbd-cart-open]").forEach(function (a) {
    a.addEventListener("click", function (e) { e.preventDefault(); openDrawer(a); });
  });
  if (overlay) overlay.addEventListener("click", closeDrawer);
  $$("[data-fbd-drawer-close]").forEach(function (b) { b.addEventListener("click", closeDrawer); });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var dlg = $("dialog[open]");
    if (dlg) return;                     // the dialog handles its own Esc; close only the topmost layer (B-023)
    closeDrawer();
  });

  /* ---------- render ---------- */
  var linesEl = $("[data-fbd-lines]");
  var emptyEl = $("[data-fbd-empty]");
  var footEl = $("[data-fbd-foot]");
  var totalEl = $("[data-fbd-total]");
  var upsellEl = $("[data-fbd-upsell]");

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;   // textContent only: product data is never parsed as HTML (B-016)
    return n;
  }

  function render() {
    var count = cart.items.reduce(function (n, l) { return n + l.quantity; }, 0);
    $$("[data-fbd-cart-count]").forEach(function (c) { c.textContent = count; });
    if (!linesEl) return;

    linesEl.textContent = "";
    cart.items.forEach(function (l) {
      var li = el("li", "fbd-line" + (l.loading ? " is-loading" : ""));
      li.dataset.key = l.key;
      var img = el("img", "fbd-line__img");
      if (l.image) img.src = l.image + (l.image.indexOf("?") > -1 ? "&" : "?") + "width=200";
      img.alt = ""; img.width = 76; img.height = 101; img.loading = "lazy";
      var info = el("div");
      var title = el("a", null); title.href = l.url;
      title.appendChild(el("p", "fbd-line__title", l.product_title));
      info.appendChild(title);
      if (l.variant_title && l.variant_title !== "Default Title") info.appendChild(el("div", "fbd-line__meta", "Size " + l.variant_title));
      var row = el("div", "fbd-line__row");
      var qty = el("div", "fbd-qty"); qty.setAttribute("role", "group"); qty.setAttribute("aria-label", "Quantity for " + l.product_title);
      var minus = el("button", "fbd-qty__btn", "−"); minus.type = "button"; minus.setAttribute("aria-label", "Decrease quantity");
      var val = el("span", "fbd-qty__val", String(l.quantity)); val.setAttribute("aria-live", "polite");
      var plus = el("button", "fbd-qty__btn", "+"); plus.type = "button"; plus.setAttribute("aria-label", "Increase quantity");
      minus.addEventListener("click", function () { setQty(l.key, l.quantity - 1); });
      plus.addEventListener("click", function () { setQty(l.key, l.quantity + 1); });
      qty.appendChild(minus); qty.appendChild(val); qty.appendChild(plus);
      row.appendChild(qty);
      row.appendChild(el("span", "fbd-price", money(l.loading || l.final_line_price == null ? l.price * l.quantity : l.final_line_price)));
      info.appendChild(row);
      var rm = el("button", "fbd-linkbtn", "Remove"); rm.type = "button"; rm.style.marginTop = "10px";
      rm.addEventListener("click", function () { setQty(l.key, 0); });
      info.appendChild(rm);
      if (l.error) info.appendChild(el("p", "fbd-line__err", l.error));
      li.appendChild(img); li.appendChild(info);
      linesEl.appendChild(li);
    });

    var empty = cart.items.length === 0;
    if (emptyEl) emptyEl.hidden = !empty;
    if (footEl) footEl.hidden = empty;
    var pending = cart.items.some(function (l) { return l.loading; });
    if (totalEl) totalEl.textContent = money(pending || cart.total_price == null
      ? cart.items.reduce(function (n, l) { return n + (l.final_line_price != null && !l.loading ? l.final_line_price : l.price * l.quantity); }, 0)
      : cart.total_price);
    renderUpsell();
  }

  /* Upsells: server-rendered (sections/fbd-cart-upsell.liquid); swap in the latest copy and wire its size chips. */
  function renderUpsell() {
    if (latestUpsell == null) return;
    var holder = document.getElementById("shopify-section-" + UPSELL_SECTION);
    if (!holder) return;
    var doc = new DOMParser().parseFromString(latestUpsell, "text/html");
    var fresh = doc.getElementById("shopify-section-" + UPSELL_SECTION);
    holder.innerHTML = fresh ? fresh.innerHTML : "";
    latestUpsell = null;
    $$("[data-fbd-qa-form]", holder).forEach(wireQuickAdd);
  }

  /* ---------- mutations ---------- */
  var toastEl = $("[data-fbd-toast]");
  var toastTimer = null;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove("is-visible"); }, 2600);
  }

  function addToCart(input, opener) {
    var d = lineDataFromInput(input);
    if (!d) return Promise.resolve();
    var variantId = d.id;
    var existing = cart.items.filter(function (l) { return Number(l.id) === variantId; })[0];
    if (existing) { existing.quantity += 1; existing.loading = true; }
    else cart.items.push({
      key: "pending:" + variantId, id: variantId, handle: d.handle, product_title: d.product_title,
      variant_title: d.variant_title, price: d.price, quantity: 1,
      image: d.image, url: d.url, loading: true, error: false
    });
    render();
    openDrawer(opener);
    return api.add(variantId, 1)
      .then(api.get)
      .then(function (fresh) { cart = fresh; render(); })              // fresh state carries no loading flag (trap #16)
      .catch(function (err) {
        return api.get().then(function (fresh) { cart = fresh; render(); toast(err.message || "Couldn't add that. Try again."); });
      });
  }

  var qtyTimers = {};
  function setQty(key, qty) {
    var line = cart.items.filter(function (l) { return l.key === key; })[0];
    if (!line) return;
    line.quantity = Math.max(0, qty);
    line.loading = true;
    if (qty === 0) cart.items = cart.items.filter(function (l) { return l.key !== key; });
    render();
    clearTimeout(qtyTimers[key]);                                       // coalesce rapid taps per line (B-052)
    qtyTimers[key] = setTimeout(function () {
      api.change(key, Math.max(0, qty))
        .then(function (fresh) { cart = fresh; render(); })
        .catch(function () {
          api.get().then(function (fresh) {
            cart = fresh;
            cart.items.forEach(function (l) { if (l.key === key) l.error = "Couldn't update. Try again."; });
            render();
          });
        });
    }, 280);
  }

  /* ---------- quick add (cards + upsell) ---------- */
  function wireQuickAdd(form) {
    form.addEventListener("change", function (e) {
      if (e.target.name !== "id") return;
      var opener = form.closest("[data-fbd-qa]");
      var toggle = opener && $("[data-fbd-qa-toggle]", opener);
      addToCart(e.target, toggle).then(function () {
        e.target.checked = false;
        if (opener && openQa === opener) closeQa(false);   // collapse the card's dropdown once the add settles
      });
    });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var picked = $("input[name=id]:checked", form);
      if (picked) addToCart(picked);
    });
  }
  /* Card dropdown: ADD TO CART drops the sizes down. One open at a time; outside click or Esc closes it. */
  var openQa = null;
  function closeQa(returnFocus) {
    if (!openQa) return;
    $("[data-fbd-qa-toggle]", openQa).setAttribute("aria-expanded", "false");
    $("[data-fbd-qa-panel]", openQa).hidden = true;
    if (returnFocus) $("[data-fbd-qa-toggle]", openQa).focus();
    openQa = null;
  }
  $$("[data-fbd-qa]").forEach(function (wrap) {
    var toggle = $("[data-fbd-qa-toggle]", wrap);
    var panel = $("[data-fbd-qa-panel]", wrap);
    if (toggle && panel) {
      toggle.hidden = false;
      panel.hidden = true;
      toggle.addEventListener("click", function () {
        var wasOpen = openQa === wrap;
        closeQa(false);
        if (wasOpen) return;
        toggle.setAttribute("aria-expanded", "true");
        panel.hidden = false;
        openQa = wrap;
        var first = $("input:not(:disabled)", panel); if (first) first.focus();
      });
    }
    var form = $("[data-fbd-qa-form]", wrap);
    if (form) wireQuickAdd(form);
  });
  document.addEventListener("click", function (e) {
    if (openQa && !openQa.contains(e.target)) closeQa(false);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && openQa) { e.stopImmediatePropagation(); closeQa(true); }
  }, true);   // capture: the open dropdown is the topmost layer, so it closes before the drawer (B-023)

  /* ---------- PDP buy box ---------- */
  var atcForm = $("[data-fbd-atc-form]");
  if (atcForm) {
    var atcBtn = $("[data-fbd-atc]", atcForm);
    var note = $("[data-fbd-atc-note]", atcForm);
    var stockEl = $("[data-fbd-stock]", atcForm);
    var pickedEl = $("[data-fbd-picked]", atcForm);
    var notifyForm = $("[data-fbd-notify]");
    var stickySelect = $("[data-fbd-sticky-select]");
    var STR = readJSON("[data-fbd-pdp-strings]", {});
    var fill = function (tpl, size, n) { return String(tpl || "").replace("{size}", size).replace("{n}", n); };
    var radios = $$("input[name=id]", atcForm);

    // Sold-out sizes ship disabled (no-JS: unselectable). With JS they become a notify-me choice.
    radios.forEach(function (r) { if (r.hasAttribute("data-soldout")) r.disabled = false; });

    function picked() { return $("input[name=id]:checked", atcForm); }

    function syncChoice() {
      var r = picked();
      note.textContent = "";
      if (!r) return;
      var size = r.dataset.size, soldOut = r.hasAttribute("data-soldout"), qty = parseInt(r.dataset.qty, 10);
      pickedEl.textContent = size;
      stockEl.textContent = (!soldOut && qty > 0 && qty <= 2) ? fill(STR.low_stock, size, qty) : "";
      // Sold-out size: the buy buttons step aside and the notify form is the one action.
      atcBtn.hidden = soldOut;
      var bn = $("[data-fbd-buynow]"); if (bn) { bn.hidden = soldOut; bn.classList.remove("is-locked"); }
      if (notifyForm) {
        notifyForm.hidden = !soldOut;
        notifyForm.classList.toggle("is-active", soldOut);
        if (soldOut) {
          $("[data-fbd-notify-note]", notifyForm).textContent = fill(STR.notify_note, size);
          $("[data-fbd-notify-submit]", notifyForm).textContent = fill(STR.notify_size_cta, size);
          $("[data-fbd-notify-tags]", notifyForm).value = "restock," + atcForm.dataset.fbdHandle + "," + size;
        }
      }
      if (stickySelect && stickySelect.value !== r.value) stickySelect.value = soldOut ? "" : r.value;
    }

    atcForm.addEventListener("change", function (e) { if (e.target.name === "id") syncChoice(); });
    atcForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var r = picked();
      if (!r) {
        note.textContent = "Choose a size first.";
        var first = $("input[name=id]:not([data-soldout])", atcForm);
        if (first) first.focus();
        return;
      }
      if (r.hasAttribute("data-soldout")) {           // never add a sold-out variant (B-050: add.js no longer refuses it)
        var email = notifyForm && $("input[type=email]", notifyForm);
        if (email) email.focus();
        return;
      }
      addToCart(r, atcBtn);
    });

    // Notify form posts natively (Shopify customer form, tagged restock + product + size). Remember the size so the
    // confirmation after the reload can name it.
    if (notifyForm) {
      var posted = $("[data-fbd-notify-posted]", notifyForm);
      if (posted) {
        notifyForm.hidden = false;
        var sz = null; try { sz = sessionStorage.getItem("fbd-notify-size"); } catch (e) {}
        if (sz) posted.textContent = fill(STR.notify_done, sz);
      } else {
        notifyForm.hidden = true;
        notifyForm.addEventListener("submit", function () {
          var r = picked(); try { if (r) sessionStorage.setItem("fbd-notify-size", r.dataset.size); } catch (e) {}
        });
      }
    }

    // Shop Pay / Apple Pay button: locked until a size is picked (it reads the form's picked size).
    var payWrap = $("[data-fbd-buynow]");
    if (payWrap) {
      payWrap.classList.add("is-locked");
      payWrap.addEventListener("click", function (e) {
        if (payWrap.classList.contains("is-locked")) { e.preventDefault(); note.textContent = "Choose a size first."; }
      }, true);
    }

    var sticky = $("[data-fbd-sticky]");
    if (sticky) {
      sticky.setAttribute("inert", "");
      // Position check on scroll, not IntersectionObserver: a fast jump from below the button
      // to above it never crosses the viewport, so an observer would never fire.
      var ticking = false;
      var syncSticky = function () {
        ticking = false;
        var show = atcBtn.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle("is-visible", show);
        if (show) sticky.removeAttribute("inert"); else sticky.setAttribute("inert", "");   // B-035
      };
      window.addEventListener("scroll", function () {
        if (!ticking) { ticking = true; requestAnimationFrame(syncSticky); }
      }, { passive: true });
      syncSticky();
      if (stickySelect) stickySelect.addEventListener("change", function () {
        var r = radios.filter(function (x) { return x.value === stickySelect.value; })[0];
        if (r) { r.checked = true; syncChoice(); }
      });
      $("[data-fbd-sticky-add]", sticky).addEventListener("click", function () {
        var r = picked();
        if (r && !r.hasAttribute("data-soldout")) { addToCart(r, $("[data-fbd-sticky-add]", sticky)); return; }
        if (stickySelect) stickySelect.focus();
      });
    }
  }

  /* ---------- scroll rows with arrow buttons (desktop) ---------- */
  $$("[data-fbd-arrows]").forEach(function (wrap) {
    var row = document.getElementById(wrap.getAttribute("data-fbd-arrows"));
    if (!row) return;
    var btns = $$("[data-fbd-scroll]", wrap);
    function sync() {
      var max = row.scrollWidth - row.clientWidth - 2;
      btns.forEach(function (b) { b.disabled = b.dataset.fbdScroll === "-1" ? row.scrollLeft <= 2 : row.scrollLeft >= max; });
    }
    btns.forEach(function (b) {
      b.addEventListener("click", function () { row.scrollBy({ left: Number(b.dataset.fbdScroll) * row.clientWidth * 0.8 }); });
    });
    row.addEventListener("scroll", function () { requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener("resize", sync);
    sync();
  });

  /* ---------- dialogs (size guide) ---------- */
  $$("[data-fbd-dialog-open]").forEach(function (b) {
    var dlg = document.getElementById(b.getAttribute("aria-controls"));
    if (!dlg || !dlg.showModal) return;
    b.addEventListener("click", function (e) { e.preventDefault(); dlg.showModal(); });
    dlg.addEventListener("click", function (e) { if (e.target === dlg) dlg.close(); });
    $$("[data-fbd-dialog-close]", dlg).forEach(function (c) { c.addEventListener("click", function () { dlg.close(); }); });
  });

  /* ---------- mobile nav ---------- */
  var menuBtn = $("[data-fbd-menu]");
  var mobileNav = $("#fbd-mobile-nav");
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener("click", function () {
      var open = menuBtn.getAttribute("aria-expanded") === "true";
      menuBtn.setAttribute("aria-expanded", String(!open));
      menuBtn.textContent = open ? "Menu" : "Close";
      mobileNav.hidden = open;
    });
  }

  /* BFCache: a restored page must not keep a half-open drawer or stale flags (trap #5). */
  window.addEventListener("pageshow", function (e) {
    if (e.persisted) { closeDrawer(); Promise.all([api.get(), api.upsell()]).then(function (res) { cart = res[0]; render(); }); }
  });

  if (drawer) { drawer.setAttribute("inert", ""); drawer.setAttribute("aria-hidden", "true"); }
  // Lines and upsells are already server-rendered; render() only rebinds the line controls.
  render();
  var upHolder = document.getElementById("shopify-section-" + UPSELL_SECTION);
  if (upHolder) $$("[data-fbd-qa-form]", upHolder).forEach(wireQuickAdd);

  // Collection sort: submit on change.
  $$("[data-fbd-autosubmit]").forEach(function (sel) { sel.addEventListener("change", function () { sel.form.submit(); }); });
})();
